import { FilterFormFieldStrategyType } from "@/common/types";
import dcCrossConnectTypeOptions from "../filter-options/dcCrossConnect.options";

const crossConnectFormFilterStrategy: FilterFormFieldStrategyType[] = [
  {
    key: "Quantity",
    element: {
      inputType: "range",
      label: "BandWidth",
      required: false,
      name: "DcServiceCrossContent-quantity",
      rangeMax: 100,
      rangeMin: 0,
    },
  },
  {
    key: "Type",
    element: {
      inputType: "select",
      label: "Access Technology",
      required: false,
      name: "DcServiceCrossContent-DcServiceType",
      rangeMax: 10000,
      rangeMin: 0,
      options: dcCrossConnectTypeOptions,
    },
  },
  //   {
  //     key: "Interface",
  //     element: {
  //       inputType: "checkboxGroup",
  //       label: "Interface",
  //       name: "crossConnect-interface",
  //       required: false,
  //       options: diaInterfaceTechOptions,
  //     },
  //   },
];

export default crossConnectFormFilterStrategy;
